import {
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
  Select,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import i18n from "i18next";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

const PreOrdersFilter = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <TextField
        sx={{
          width: "250px",
          backgroundColor: "#F9F9F9",
        }}
        label={i18n.t("preOrders.fields.research")}
        value={null}
        onChange={() => {}}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      <FormControl>
        <InputLabel id="status">{i18n.t("preOrders.fields.status")}</InputLabel>
        <Select
          id="status"
          label={i18n.t("preOrders.fields.status")}
          IconComponent={KeyboardArrowDownOutlinedIcon}
          sx={{
            width: "190px",
            backgroundColor: "#F9F9F9",
          }}
        />
      </FormControl>
    </Box>
  );
};

export default PreOrdersFilter;
